/* unplugin-vue-components disabled */import script from "./HeatHadView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeatHadView.vue?vue&type=script&setup=true&lang=js"

import "./HeatHadView.vue?vue&type=style&index=0&id=b815a712&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b815a712"]])

export default __exports__